import React from "react";
import { Moon, Sun } from "lucide-react";
import useReadingMode from "@/hooks/useReadingMode";
import { cn } from "@/lib/utils";

/**
 * READING MODE: BROADSHEET (light) / DOSSIER (dark)
 * variant: "rail" (compact, vertical rail) | "bar" (inline with label)
 */
export default function ReadingModeToggle({ variant = "bar", className }) {
  const { isDark, toggle } = useReadingMode();
  const label = isDark ? "Dossier" : "Broadsheet";

  if (variant === "rail") {
    return (
      <button
        type="button"
        data-testid="reading-mode-toggle"
        onClick={toggle}
        aria-label={`Reading mode: ${label}. Switch to ${isDark ? "broadsheet" : "dossier"}.`}
        title={`Reading mode — ${label}`}
        className={cn(
          "group flex h-8 w-8 items-center justify-center rounded-[4px] border transition-colors",
          "border-ink/20 text-ink/55 hover:border-nexus hover:text-nexus",
          className
        )}
      >
        {isDark ? <Sun size={13} strokeWidth={1.9} /> : <Moon size={13} strokeWidth={1.9} />}
        <span data-testid="reading-mode-toggle-label" className="sr-only">
          {label}
        </span>
      </button>
    );
  }

  return (
    <button
      type="button"
      data-testid="reading-mode-toggle"
      onClick={toggle}
      aria-label={`Reading mode: ${label}. Switch to ${isDark ? "broadsheet" : "dossier"}.`}
      className={cn(
        "inline-flex items-center gap-2 rounded-[4px] border px-2.5 py-1.5 font-mono text-[9.5px] tracking-[0.2em] uppercase transition-colors",
        "border-ink/20 text-ink/60 hover:border-nexus hover:text-nexus",
        className
      )}
    >
      {isDark ? <Sun size={12} strokeWidth={1.9} /> : <Moon size={12} strokeWidth={1.9} />}
      <span data-testid="reading-mode-toggle-label">{label}</span>
    </button>
  );
}
